import React, { useEffect, useRef } from "react";
import { MenuItems } from "../MenuItems";
import { Link, useLocation } from "react-router-dom";
import "./Dropdown.css";
import PropTypes from "prop-types";

const Dropdown = ({ setDropdown }) => {
  const dropdownRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setDropdown]);

  return (
    <ul ref={dropdownRef} className="dropdown-menu" style={{ zIndex: 1000 }}>
      {MenuItems.map((item) => {
        const isActive = location.pathname === item.path;

        return (
          <li key={item.path} className={isActive ? "disabled" : undefined}>
            {isActive ? (
              <span
                className={`${item.cName} dropdown-link--disabled`}
                aria-disabled="true"
                aria-current="page"
              >
                {item.title}
              </span>
            ) : (
              <Link
                className={item.cName}
                to={item.path}
                onClick={() => setDropdown(false)}
              >
                {item.title}
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );
};

Dropdown.propTypes = { setDropdown: PropTypes.func.isRequired };
export default Dropdown;
